import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useRPC} from '../../../../hooks/rpc';
import {SettingReadOnlyRowComponent} from '../../../../components/Settings/SettingReadOnlyRowComponent';
import {SystemInfo} from '../../../../types/system-info';
import {useMessage} from '../../../../hooks/message';
import {useLocalization} from '../../../../hooks/localization';

const BACK_URL = '/settings';

export const SystemInfoScreen = memo(function SystemInfoScreen() {
    const [rpc] = useRPC();
    const {failure} = useMessage();
    const {t} = useLocalization();

    const [systemInfo, setSystemInfo] = useState<SystemInfo>(null);

    const loadInfo = useCallback(() => {
        rpc.getSystemInfo()
            .then(setSystemInfo)
            .catch(failure);
        // eslint-disable-next-line
    }, []);

    const onRefreshPressed = useCallback(() => {
        loadInfo();
    }, [loadInfo]);

    const buttons = useMemo(() => [
        {
            text: t('refresh'),
            className: 'green',
            onClick: onRefreshPressed,
        },
    ], [t, onRefreshPressed]);

    useEffect(() => {
        loadInfo();
    }, [loadInfo]);

    const voltageControl = parseInt(systemInfo?.voltage_supply) < 10500 ? ' ( Low Power ) ' : ''
    return (
        <PasswordContainer requiredRole='service' isFullscreen={true}>
            <SettingsPageContainer
                className='service-edit'
                buttons={buttons}
                backUrl={BACK_URL}
                title={t('system_information')}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        {
                            renderIf(systemInfo)(() =>
                                <>
                                    <SettingReadOnlyRowComponent
                                        title={t('ethernet_lan_ip')}
                                        value={systemInfo.lan_ip}/>
                                    <SettingReadOnlyRowComponent
                                        title={t('wifi_ip')}
                                        value={systemInfo.wifi_ip}/>
                                    <SettingReadOnlyRowComponent
                                        title={t('ethernet_wan_ip')}
                                        value={systemInfo.wan_ip}/>
                                    <SettingReadOnlyRowComponent
                                        title={t('mac_address')}
                                        value={systemInfo.mac_address}/>
                                    <SettingReadOnlyRowComponent
                                        title={t('software_version')}
                                        value={systemInfo.version}/>
                                    <SettingReadOnlyRowComponent
                                        title={t('image_version')}
                                        value={systemInfo.image_version}/>
                                    <SettingReadOnlyRowComponent
                                        title={"FE " + t('software_version')}
                                        value={"1.29.15"}/>
                                </>,
                            )
                        }
                    </div>
                    <div className='content-wrapper'>
                        {
                            renderIf(systemInfo)(() =>
                                <>
                                    <SettingReadOnlyRowComponent
                                        title={t('system_time')}
                                        value={systemInfo.system_time}/>
                                    <SettingReadOnlyRowComponent
                                        title={"Voltage"}
                                        value={(parseInt(systemInfo.voltage_supply) / 1000).toString() + ' ' + voltageControl}/>
                                    <SettingReadOnlyRowComponent
                                        title={t('cpu_temperature')}
                                        value={systemInfo.cpu_temperature}/>
                                    <SettingReadOnlyRowComponent
                                        title={t('sip_client_status')}
                                        value={systemInfo.sip_client_status}/>
                                    <SettingReadOnlyRowComponent
                                        title={'Uptime'}
                                        value={systemInfo.uptime}/>
                                    <SettingReadOnlyRowComponent
                                        title={'WorkerUptime'}
                                        value={systemInfo.worker_uptime}/>
                                    <SettingReadOnlyRowComponent
                                        title={'HW ' + t('software_version')}
                                        value={systemInfo.hw_version}/>
                                </>,
                            )
                        }
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
